import { render, staticRenderFns } from "./AppContentTypesList.vue?vue&type=template&id=aaca7dbc"
import script from "./AppContentTypesList.js?vue&type=script&lang=js&external"
export * from "./AppContentTypesList.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports